import { createFileRoute } from "@tanstack/react-router";
import ServiceAreas from "@/pages/site/ServiceAreas";

export const Route = createFileRoute("/service-areas/")({
  component: () => <ServiceAreas />,
});
